import type { ConnectorFilters, MyConnectorFilters } from "@/types/connector.types";

/**
 * Query key factory for connectors
 * Follows TanStack Query best practices for key organization
 */
export const connectorKeys = {
  all: ["connectors"] as const,
  lists: () => [...connectorKeys.all, "list"] as const,
  list: (filters?: ConnectorFilters) => [...connectorKeys.lists(), filters] as const,
  details: () => [...connectorKeys.all, "detail"] as const,
  detail: (id: string) => [...connectorKeys.details(), id] as const,
  // Database browsing
  databases: (connectorId: string) =>
    [...connectorKeys.detail(connectorId), "databases"] as const,
  schemas: (connectorId: string, database?: string) =>
    [...connectorKeys.detail(connectorId), "schemas", database] as const,
  tables: (connectorId: string, database?: string, schema?: string) =>
    [...connectorKeys.detail(connectorId), "tables", database, schema] as const,
  tableColumns: (connectorId: string, tableName: string, database?: string, schema?: string) =>
    [...connectorKeys.detail(connectorId), "tables", tableName, "columns", database, schema] as const,
  tableData: (connectorId: string, tableName: string, database?: string, schema?: string, page?: number, sort?: string | null, sortDir?: string) =>
    [...connectorKeys.detail(connectorId), "tables", tableName, "data", database, schema, page, sort, sortDir] as const,
  sheetTabs: (connectorId: string, spreadsheetId?: string) =>
    [...connectorKeys.detail(connectorId), "sheets", spreadsheetId, "tabs"] as const,
  sheetValues: (connectorId: string, spreadsheetId?: string, sheet?: string, range?: string) =>
    [...connectorKeys.detail(connectorId), "sheets", spreadsheetId, sheet, range, "values"] as const,
  redisKeys: (connectorId: string, pattern?: string, cursor?: string, count?: number) =>
    [...connectorKeys.detail(connectorId), "redis", "keys", pattern, cursor, count] as const,
  redisValue: (connectorId: string, key?: string, byteLimit?: number) =>
    [...connectorKeys.detail(connectorId), "redis", "value", key, byteLimit] as const,
  // Counts + Subtypes
  counts: () => [...connectorKeys.all, "counts"] as const,
  subtypes: () => [...connectorKeys.all, "subtypes"] as const,
  // Shares
  shares: (connectorId: string) =>
    [...connectorKeys.detail(connectorId), "shares"] as const,
  tablePermissions: (shareId: string) =>
    [...connectorKeys.all, "share-table-permissions", shareId] as const,
  // My connectors (permission-resolved)
  myConnectors: (filters?: MyConnectorFilters) =>
    [...connectorKeys.all, "my-connectors", filters] as const,
};
